// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_ACC_MINT, SUC_ACC_MINT } from '../../../../utils/strings';

export const useAcceptMintRequest = () => {
  const { submit } = useExerciseSubmission(
    RegistrarService.RegistrarService_AcceptMintRequest,
    SUC_ACC_MINT,
    ERR_ACC_MINT,
  );
  return submit;
};
